import { _camelCase, _isTruthy } from '@naturalcycles/js-lib'
import { useLocation } from '@reach/router'
import { useMemo } from 'react'

export function usePageNameClass(): string {
  const { pathname } = useLocation()

  const pageNameClass = useMemo(() => {
    return pathname
      .split('/')
      .map(part => {
        return _camelCase(part)
      })
      .filter(_isTruthy)
      .join(' ')
  }, [pathname])

  return pageNameClass
}
